import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// The page shell says <html lang="en"> for every route, so Spanish pages were announced by screen readers
// with an English voice and browsers offered to "translate" text that was already in the reader's language.
// The Spanish routes of both sites live under /es (the Director pages, the Vynko landing and the Vynko
// mirrors), so the language follows the path and updates on every navigation.
const SPANISH_PATH = /^\/es(\/|$)/;

export function languageForPath(pathname) {
  return SPANISH_PATH.test(pathname || "") ? "es" : "en";
}

export default function HtmlLangSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.documentElement.lang = languageForPath(pathname);
  }, [pathname]);
  return null;
}
